/**
 * Existences texts (`en`) — Lot + Place model (OBR-142: OBR-143, OBR-146, OBR-14): joins the files of each slice.
 * Wired into `en.ts` with a single `...existenciesEn`; this way each slice edits only its own file.
 */

import { statesEn } from './states.en.js';
import { stockLineEn } from './stockLine.en.js';
import { plantaStockEn } from './plantaStock.en.js';
import { viewsEn } from './views.en.js';
import { reprintEn } from './reprint.en.js';
import { countEn } from './count.en.js';
import { fefoEn } from './fefo.en.js';
import { receptionDirectEn } from './receptionDirect.en.js';
import { plantaCountEn } from './plantaCount.en.js';

export const existenciesEn = {
  ...statesEn,
  ...stockLineEn,
  ...plantaStockEn,
  ...viewsEn,
  ...reprintEn,
  ...countEn,
  ...fefoEn,
  ...receptionDirectEn,
  ...plantaCountEn,
} as const;
